import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PUBLISHABLE_KEY } from "./stripe-config";

export const stripePromise = STRIPE_PUBLISHABLE_KEY ?
  loadStripe(STRIPE_PUBLISHABLE_KEY) :
  null;

